import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/registers/login'
import Register from '../views/registers/index'
import Genre from '../views/registers/genre'
import Upgrade from '../views/upgrade/index'
import UpgradeGenre from '../views/upgrade/genre'
import UpgradeForm from '../views/upgrade/form'
import RegForm from '../views/registers/form'
import ResetPassword from '../views/registers/resetPassword'
import ResetForm from '../views/registers/resetForm'
import Index from '../views/index/index'
import Withdraw from '../views/index/withdraw'
import WithdrawManage from '../views/index/withdrawManage'
import ArticleDetails from '../views/index/details'
import Agency from '../views/agency/index'
import Share from '../views/agency/share'
import Sell from '../views/agency/sell'
import SellOrders from '../views/agency/sellOrders'
import Teaching from '../views/agency/teaching'
import AgencyOrders from '../views/agency/orders'
import AgencyPerson from '../views/agency/person'
import AgencyTeam from '../views/agency/team'
import Retails from '../views/retails/index'
import RetailsShare from '../views/retails/share'
import User from '../views/users/index'
import Setting from '../views/users/setting'
import UserEdit from '../views/users/edit'
import AccountList from '../views/users/accountList'
import Information from '../views/users/information'
import Questions from '../views/users/questions'
import Address from '../views/users/address'
import addressAddEdit from '../views/users/addressAddEdit'
import Orders from '../views/users/orders'
import OrdersShow from '../views/users/ordersShow'
import Income from '../views/users/income'
import Security from '../views/users/security'
import Binding from '../views/users/binding'
import ResetPwd from '../views/users/resetPwd'
import Goods from '../views/goods/index'
import GoodsDetails from '../views/goods/details'
import Payment from '../views/payment/index'
import PaymentPay from '../views/payment/pay'
import PaymentSucceed from '../views/payment/succeed'
import Scheme from '../views/scheme/details'
import ManageRecharge from '../views/manage/recharge'
import ManageRechargeRecord from '../views/manage/rechargeRecord'
import ManageOrders from '../views/manage/orders'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'details.vue',
      component: Index,
      meta: {
        title: '首页',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登录'
      },
    },
    {
      path: '/register/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        title: '忘记密码'
      },
    },
    {
      path: '/register/resetForm',
      name: 'resetForm',
      component: ResetForm,
      meta: {
        title: '重置密码'
      },
    },
    {
      path: '/register/index',
      name: 'register',
      component: Register,
      meta: {
        title: '注册页'
      },
    },
    {
      path: '/register/genre/:type',
      name: 'Genre',
      component: Genre,
      meta: {
        title: '类型选择页'
      }
    },
    {
      path: '/register/form/:type',
      name: 'Form',
      component: RegForm,
      meta: {
        title: '注册填写信息'
      }
    },
    {
      path: '/upgrade/index',
      name: 'upgrade',
      component: Upgrade,
      meta: {
        title: '升级会员',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/upgrade/genre/:type',
      name: 'upgradeGenre',
      component: UpgradeGenre,
      meta: {
        title: '升级套餐选择',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/upgrade/form/:type',
      name: 'upgradeForm',
      component: UpgradeForm,
      meta: {
        title: '提交升级套餐',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/index/withdraw',
      name: 'Withdraw',
      component: Withdraw,
      meta: {
        title: '申请提现',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/index/withdrawManage',
      name: 'withdrawManage',
      component: WithdrawManage,
      meta: {
        title: '提现管理',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/index/details',
      name: 'articleDetails',
      component: ArticleDetails,
      meta: {
        title: '文章详情',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/index',
      name: 'Agency',
      component: Agency,
      meta: {
        title: '代理',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/share',
      name: 'Share',
      component: Share,
      meta: {
        title: '邀请代理',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/sell',
      name: 'sell',
      component: Sell,
      meta: {
        title: '我的经销',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/sellOrders',
      name: 'sellOrders',
      component: SellOrders,
      meta: {
        title: '团队订单',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/teaching',
      name: 'teaching',
      component: Teaching,
      meta: {
        title: '模式讲解',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/orders',
      name: 'agencyOrders',
      component: AgencyOrders,
      meta: {
        title: '下级订单',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/person',
      name: 'person',
      component: AgencyPerson,
      meta: {
        title: '个人业绩',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/agency/team',
      name: 'team',
      component: AgencyTeam,
      meta: {
        title: '团队业绩',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/retails/index',
      name: 'Retails',
      component: Retails,
      meta: {
        title: '推广',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/retails/share',
      name: 'retailsShare',
      component: RetailsShare,
      meta: {
        title: '零售',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/index',
      name: 'user',
      component: User,
      meta: {
        title: '我的',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/setting',
      name: 'Setting',
      component: Setting,
      meta: {
        title: '基础设置',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/questions',
      name: 'Questions',
      component: Questions,
      meta: {
        title: '常见问题',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/address',
      name: 'Address',
      component: Address,
      meta: {
        title: '收货地址',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/addressAddEdit',
      name: 'addressAddEdit',
      component: addressAddEdit,
      meta: {
        title: '新增地址',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/information',
      name: 'information',
      component: Information,
      meta: {
        title: '消息',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/orders',
      name: 'orders',
      component: Orders,
      meta: {
        title: '我的订单',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/ordersShow',
      name: 'ordersShow',
      component: OrdersShow,
      meta: {
        title: '订单详情',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/edit',
      name: 'userEdit',
      component: UserEdit,
      meta: {
        title: '个人资料',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/accountList',
      name: 'accountList',
      component: AccountList,
      meta: {
        title: '收款账号',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/income',
      name: 'income',
      component: Income,
      meta: {
        title: '收支明细',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/security',
      name: 'security',
      component: Security,
      meta: {
        title: '账户安全',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/binding',
      name: 'binding',
      component: Binding,
      meta: {
        title: '绑定手机号',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/users/resetPwd',
      name: 'resetPwd',
      component: ResetPwd,
      meta: {
        title: '修改登录密码',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/goods/index',
      name: 'Goods',
      component: Goods,
      meta: {
        title: '商品列表',
        show: true,
        requireAuth: true,
      }
    },
    {
      path: '/goods/details',
      name: 'GoodsDetails',
      component: GoodsDetails,
      meta: {
        title: '商品详情',
        show: true,
        requireAuth: true,
      },
    },
    {
      path: '/payment/index',
      name: 'payment',
      component: Payment,
      meta: {
        title: '确认订单',
        show: true,
        requireAuth: true,
      },
    },
    {
      path: '/payment/pay',
      name: 'paymentPay',
      component: PaymentPay,
      meta: {
        title: '收银台',
        show: true,
        requireAuth: true,
      },
    },
    {
      path: '/payment/succeed',
      name: 'paymentSucceed',
      component: PaymentSucceed,
      meta: {
        title: '支付成功',
        show: true,
        requireAuth: true,
      },
    },
    {
      path: '/scheme/details',
      name: 'Scheme',
      component: Scheme,
      meta: {
        title: '详情页',
        show: true,
        requireAuth: true,
      },
    },
    {
      path: '/manage/recharge',
      name: 'manageRecharge',
      component: ManageRecharge,
      meta: {
        title: '会员充值',
        show: true,
        requireAuth: true,
      },
    },
    {
      path: '/manage/rechargeRecord',
      name: 'manageRechargeRecord',
      component: ManageRechargeRecord,
      meta: {
        title: '充值记录',
        show: true,
        requireAuth: true,
      },
    },
    {
      path: '/manage/orders',
      name: 'manageOrders',
      component: ManageOrders,
      meta: {
        title: '订单列表',
        show: true,
        requireAuth: true,
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js